import React from 'react';
import {
  formatPricingSummary,
  formatValidityLabel,
} from '../../utils/giftCardTemplateForm';

/**
 * Lot 4C — Liste templates cartes cadeaux.
 * Statut Admin (Active/Inactive) ≠ publication catalogue (catalogVisible).
 */
export default function GiftCardTemplateList({
  items = [],
  filter = 'all',
  busyId = null,
  onEdit,
  onToggleActif,
}) {
  const filtered = items.filter((t) => {
    if (filter === 'active') return t.actif;
    if (filter === 'draft' || filter === 'inactive') return !t.actif;
    return true;
  });

  if (filtered.length === 0) {
    return (
      <div
        className="rounded-xl border border-dashed border-gray-300 bg-gray-50 px-6 py-10 text-center"
        data-testid="gift-card-empty"
      >
        <p className="text-gray-700 font-medium">Aucune carte cadeau</p>
        <p className="text-sm text-gray-500 mt-1">
          Créez une offre pour préparer vos futures ventes.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid="gift-card-list">
      {filtered.map((t) => (
        <div
          key={t.id}
          className="flex flex-col sm:flex-row gap-4 items-start sm:items-center border border-gray-200 rounded-xl p-4 bg-white min-w-0"
        >
          {t.imageUrl ? (
            <img
              src={t.imageUrl}
              alt=""
              className="h-16 w-16 rounded-lg object-cover border border-gray-100 shrink-0"
            />
          ) : (
            <div className="h-16 w-16 rounded-lg bg-gray-100 shrink-0" />
          )}
          <div className="flex-1 min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <h4 className="font-semibold text-gray-900 truncate max-w-full">{t.nom}</h4>
              <span
                className={`text-xs font-semibold px-2 py-0.5 rounded-full shrink-0 ${
                  t.actif ? 'bg-green-100 text-green-800' : 'bg-gray-200 text-gray-700'
                }`}
                data-testid="gift-card-admin-status"
              >
                {t.actif ? 'Active' : 'Inactive'}
              </span>
              <span
                className={`text-xs font-semibold px-2 py-0.5 rounded-full shrink-0 ${
                  t.catalogVisible
                    ? 'bg-emerald-100 text-emerald-800'
                    : 'bg-slate-100 text-slate-600'
                }`}
                data-testid="gift-card-publish-status"
                title="Publication catalogue"
              >
                {t.catalogVisible ? 'Publiée' : 'Non publiée'}
              </span>
            </div>
            <p className="text-sm text-gray-600 mt-1 break-words">
              {t.pricingMode === 'FIXED_AMOUNTS' ? 'Montants fixes' : 'Montant libre'} ·{' '}
              {formatPricingSummary(t)}
            </p>
            <p className="text-xs text-gray-500 mt-0.5">
              Validité : {formatValidityLabel(t.defaultValidityDays)}
            </p>
          </div>
          <div className="flex flex-wrap gap-2 shrink-0 w-full sm:w-auto">
            <button
              type="button"
              className="btn-secondary text-sm flex-1 sm:flex-none"
              onClick={() => onEdit?.(t)}
              disabled={busyId === t.id}
            >
              Modifier
            </button>
            <button
              type="button"
              className="btn-secondary text-sm flex-1 sm:flex-none"
              onClick={() => onToggleActif?.(t)}
              disabled={busyId === t.id}
            >
              {t.actif ? 'Désactiver' : 'Réactiver'}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
